import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {CheckboxButton} from '../button/checkbox-button/checkbox-button';
import {FlameIcon} from '../icon/svg/flame-icon';

export function ReduxFormPriorityToggle(props: FieldProps) {
    const {input, ...rest} = props;

    return (
        <CheckboxButton
            {...input}
            {...rest}
            isLarge={true}
            icon={FlameIcon}
            label='This lead is hot'
            checked={input.value}
        />
    );
}
